import { FC, memo } from "react";
import { Box } from "@mui/material";
import Pill from "@/components/ui/Pill";
import { FaVideo, FaImage } from "react-icons/fa";
import { useSTCStatus } from "prembid-shared-library-npm/hooks";
import { ImageCarousel } from "../ImageCarousel";
import { VideoCarousel } from "../VideoCarousel";

export interface ImageAndVideoCarouselProps {
    imageUrls: string[];
    videoUrls: string[];
    stcStatus: string;
    activeTab: string;
    setActiveTab: (tab: string) => void;
    showLoading?: boolean;
}

const ImageAndVideoCarousel: FC<ImageAndVideoCarouselProps> = ({ imageUrls, videoUrls, stcStatus, activeTab, setActiveTab, showLoading = false }) => {

    const STCStatus = useSTCStatus(stcStatus);

    return <>
        <Box sx={{ position: 'relative' }}>
            {videoUrls?.length > 0 && (
                <div className="pb-media-toggle" role="tablist">
                    <button type="button" role="tab" aria-label="Photos" aria-selected={activeTab === "0"} className={activeTab === "0" ? "active" : ""} onClick={() => setActiveTab("0")}>
                        <FaImage />
                    </button>
                    <button type="button" role="tab" aria-label="Videos" aria-selected={activeTab === "1"} className={activeTab === "1" ? "active" : ""} onClick={() => setActiveTab("1")}>
                        <FaVideo />
                    </button>
                </div>
            )}

            {STCStatus && <div className="pb-media-stc"><Pill size="small" label={STCStatus} style={{ background: "#ffffff" }} /></div>}

            <div
                className={"tab-item-wrapper " + (activeTab === "0" ? "active" : "")}
                key={0}>
                <ImageCarousel images={imageUrls?.map((url) => url)} showLoading={showLoading} />
            </div>

            <div
                className={"tab-item-wrapper " + (activeTab === "1" ? "active" : "")}
                key={1}>
                <VideoCarousel videos={videoUrls?.map((url) => url)} showLoading={showLoading} showThumbnails={true} />
            </div>
        </Box>
    </>
};

export default memo(ImageAndVideoCarousel);
